<template>
  <el-dialog
    title="知识库"
    :visible.sync="knowledgeDialogVisible"
    :before-close="knowledgeHandleClose"
    width="800px"
    center
    append-to-body
  >
    <div style="height: 430px;">
      <el-row>
        <KnowledgeSearchExpand ref="searchDetail"></KnowledgeSearchExpand>
      </el-row>
      <el-row class="is-justify-center el-row--flex">
        <el-col :span="18">
          <div style="box-sizing:border-box;width:100%;">
            <el-input placeholder="请输入综合搜索内容" v-model="txtSearch" @keyup.13.native="btnDoSearch"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <el-button
            style="margin-left:20px"
            type="primary"
            icon="el-icon-search"
            title="搜索"
            @click="SearchKnowledge"
          >搜索</el-button>
        </el-col>
      </el-row>
      <el-row :span="24" class="tablePanel">
        <el-table
          :data="tableData"
          ref="knowledgeTable"
          border
          style="width: 100%;"
          highlight-current-row
          class="tableKeyword"
          @current-change="handleCurrentChange"
          @selection-change="changeFun"
          @row-dblclick="showKnowledgeDetail"
          height="260px"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="INSTANCE" label="ID编号" width="95" sortable></el-table-column>
          <el-table-column
            prop="TITLE"
            label="标题"
            width="360"
            :show-overflow-tooltip="true"
            sortable
          ></el-table-column>
          <el-table-column
            prop="TagNames"
            label="关键词"
            width="120"
            :show-overflow-tooltip="true"
            sortable
          ></el-table-column>
          <el-table-column
            prop="KNOWLEDGETYPENAME"
            label="知识类型"
            width="120"
            :show-overflow-tooltip="true"
            sortable
          ></el-table-column>
          <el-table-column
            prop="KNOWLEDGECLASSNAME"
            label="知识分类"
            width="120"
            :show-overflow-tooltip="true"
            sortable
          ></el-table-column>
          <el-table-column
            prop="CREATETIME"
            label="创建时间"
            width="170"
            :show-overflow-tooltip="true"
            sortable
            :formatter="timeFormatter"
          ></el-table-column>
          <el-table-column prop="AUTHORNAME" label="作者" width="120" sortable></el-table-column>
          <el-table-column
            prop="SOURCE"
            label="来源"
            width="100"
            :show-overflow-tooltip="true"
            sortable
            :formatter="sourceFormatter"
          ></el-table-column>
        </el-table>
      </el-row>
      <el-row :span="24" class="pagePanel">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentPageChange"
          :current-page="currentPage"
          :page-sizes="pageSizesArr"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        ></el-pagination>
      </el-row>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="knowledgeDialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="sureKnowledgeDia">确 定</el-button>
    </span>
    <KnowledgeView ref="refknowledgeDetail" :knowledgeData="knowledgeDetail" :showComment="false"></KnowledgeView>
  </el-dialog>
</template>

<script>
import KnowledgeSearchExpand from "@/views/knowledgeBase/KnowledgeSearchExpand";
import KnowledgeView from "@/views/knowledgeBase/KnowledgeView";
import {
  GetAllObjTypeBSMV,
  GetAllGeneralSelTreeEx,
  GetCommonAndUsedObjTypeBSMV,
  GetKnowledgeByParam
} from "@/api/modules/basicData/knowledge";
import { Linq, DateFormat, TimeFormat } from "@/util/common";
export default {
  components: {
    KnowledgeSearchExpand,
    KnowledgeView
  },
  data() {
    return {
      txtSearch: "",
      knowledgeDialogVisible: false,
      pageSizesArr: [2, 5, 10, 20, 30, 50, 100, 300],
      pageSize: 10,
      currentPage: 1,
      totalCount: 0,
      tableData: [],
      knowledgeSelData: [],
      searchIconState: "el-icon-arrow-down",
      knowledgeDetail: {
        TITLE: ""
      },
      summaryList: {
          ID: '',
          TASKID: '',
          CREATEUSERID: '',
          CREATEUSERNAME: '',
          CREATEDEPTID: '',
          CREATEDEPTNAME: '',
          CREATETIME: '',
          ISCOMPLETED: false,
          DetailList: [{
            ID: '',
            SUMMARYID: '',
            TITLE: '',
            CONTENT: '',
            DESCRIPTION: '',
            SAVEKMS: false,
            DeviceList: [],
            OPobjectList: [],
          }]
        },
    };
  },
  mounted() {
    // this.SearchKnowledge();
    //this.currentUser = getToken();
  },
  methods: {
    handleCurrentChange(val) {
      this.currentRow = val;
    },
    sourceFormatter(row, column) {
      if (row.SOURCE == "0") {
        return "主动添加";
      }
      return "";
    },
    //获取选中的知识
    changeFun(val) {
      this.knowledgeSelData = val;
    },
    showKnowledgeDetail(row) {
      //显示知识详情
      this.currentRow = row;
      this.knowledgeDetail = this.currentRow;
      setTimeout(() => {
        this.$refs.refknowledgeDetail.dialogFormVisible = true;
      }, 100);
    },
    timeFormatter(row, column) {
      return TimeFormat(row.CREATETIME);
    },
    timeFormat(time) {
      return TimeFormat(time);
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentPageChange(val) {
      this.currentPage = val;
    },
    //清空选择知识弹窗
    knowledgeHandleClose(done) {
      this.resetKnowledge();
      done();
    },
    //知识确定
    sureKnowledgeDia() {
      //先获取再添加
      let body = '';
      this.knowledgeSelData.forEach(c => {
        body += c.BODYSTR + "<br/>";
      });
      if(body){
        this.$emit('getValue',body);
      }
      this.resetKnowledge();
      this.knowledgeDialogVisible = false;
    },
    resetKnowledge() {
      this.$refs.searchDetail.$refs.cs1.deleteBtnClick();
      this.$refs.searchDetail.$refs.cs2.deleteBtnClick();
      this.$refs.searchDetail.$refs.cs3.deleteBtnClick();
      this.$refs.searchDetail.$refs.cs4.deleteBtnClick();
      this.$refs.knowledgeTable.clearSelection();
      this.txtSearch = "";
    },
    //知识库搜索
    SearchKnowledge() {
      var para = null;
      let hideOrShowAdvanceSearch =
        this.searchIconState != "el-icon-arrow-down";
      if (hideOrShowAdvanceSearch) {
        para = {
          PageIndex: this.currentPage,
          PageSize: this.pageSize,
          SearchTxt: this.txtSearch,
          Para: this.$refs.searchDetail.searchPara
        };
      } else {
        para = {
          PageIndex: this.currentPage,
          PageSize: this.pageSize,
          SearchTxt: this.txtSearch,
          Para: {
            SortStyle: 1
          }
        };
      }
      GetKnowledgeByParam(para)
        .then(res => {
          this.tableData = res.Items;
          this.totalCount = res.TotalItems;
        })
        .catch(err => {
          console.log("GetKnowledgeByParam error");
        });
    }
  },
  watch: {
      pageSize() {
        this.SearchKnowledge();
      },
      currentPage() {
        this.SearchKnowledge();
      },
    },
};
</script>

<style lang="scss" scoped>
</style>
